import { observer } from 'mobx-react';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';
import { NewConsumerRecruitmentForm } from 'owa-feedback';
import * as React from 'react';

@observer
@lightable
export default class NewConsumerRecruitmentFormCallout extends React.Component<LightningProps, {}> {
    /**
     * Rendering of the lightning callout
     */
    public render() {
        return <NewConsumerRecruitmentForm onExit={this.onExit} />;
    }

    private onExit = () => {
        lighted(this.props.lid);
    };
}
